import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  const data = fetchData;
  // console.log("checking data in product", fetchData);
  console.log(data);
  const formattedData = useMemo(() => {
    const rows = [];

    if (data && Array.isArray(data)) {
      data.forEach((item, index) => {
        const row = {
          // id: index,
          // picture: product.Pictures.map((picture) => ({
          //   id: picture.id,
          //   picture: picture.pic
          //     .split("http")
          //     .filter(Boolean)
          //     .map((url) => `http${url.trim()}`),
          // })),
          marketplace_package_id: item.marketplace_package_id,
          credit: item.credit,
          name_package: item.name_package,
          price: item.price,
          status: item.status,
          total_day: item.total_day,
          start_date: moment(item.start_date).format("DD/MM/YYYY\n "),
          end_date: moment(item.end_date).format("DD/MM/YYYY\n "),
          created_date: moment(item.created_date).format(
            "DD/MM/YYYY\n เวลา HH:mm:ss น."
          ),
          updated_date: moment(item.updated_date).format(
            "DD/MM/YYYY\n เวลา HH:mm:ss น."
          ),
          package_type: item.package_type,
        };

        rows.push(row);
      });
    }

    return rows;
  }, [data]);

  return formattedData;
};

export default useProductData;
